export const immutableRemove = (array: any[], index: number) => {
  const immutableCopy = [...array];
  immutableCopy.splice(index, 1);
  return immutableCopy;
};
